import styled, { css } from 'styled-components';

interface Props {
  $height?: string;
  $backgroundColor?: string;
}

function heightStyle({ $height }: Props) {
  if ($height) {
    return css`
      height: ${$height};
    `;
  }
}
function backgroundColorStyle({ $backgroundColor }: Props) {
  if ($backgroundColor) {
    return css`
      background-color: ${$backgroundColor};
    `;
  }
}

export default styled.div<Props>`
  width: 100%;
  ${heightStyle}
  ${backgroundColorStyle}
`;
